declare global {
  interface Window {
    webkit?: {
      messageHandlers?: {
        authExpired?: { postMessage: (msg: unknown) => void };
        authError?: { postMessage: (msg: unknown) => void };
      };
    };
    NativeApp?: {
      onAuthExpired?: (json: string) => void;
      onAuthError?: (json: string) => void;
    };
    __bxMobileBridge: {
      setTitle: (title: string | null) => void;
    };
  }
}

export function isNativeWebView(): boolean {
  return !!(
    window.webkit?.messageHandlers?.authExpired ||
    window.NativeApp?.onAuthExpired
  );
}

export function isWebViewSession(): boolean {
  return document.cookie.includes('native_app_session=true');
}

export function setBxMobileTitle(title: string | null): void {
  if (isBXMobileWebView() && window.__bxMobileBridge) {
    window.__bxMobileBridge.setTitle(title);
  }

  // For debugging, log the title if we're in a BXMobile webview but the bridge is not available
  if (isBXMobileWebView() && !window.__bxMobileBridge) {
    // eslint-disable-next-line no-console
    console.log(`setBxMobileTitle: ${title} (__bxMobileBridge not available)`);
  }
}

export function isBXMobileWebView(): boolean {
  return navigator.userAgent.includes('BXMobile');
}

export function notifyNativeAppAuthExpired(): void {
  const payload = {
    reason: 'session_expired',
    currentUrl: window.location.href,
  };

  if (window.webkit?.messageHandlers?.authExpired) {
    window.webkit.messageHandlers.authExpired.postMessage(payload);
  } else if (window.NativeApp?.onAuthExpired) {
    window.NativeApp.onAuthExpired(JSON.stringify(payload));
  }
}

export function handleAuthExpiration(): void {
  if (isNativeWebView()) {
    notifyNativeAppAuthExpired();
  } else {
    window.location.href = '/users/sign_in';
  }
}
